import React, { useEffect, useState } from "react";
import "./Navbar.css";
import Toggle from "../Toggle/Toggle";
import { Link } from "react-scroll";
import LogoAdele from "../../img/logo-adele.png";

const links = [
  { to: "Accueil", label: "Accueil" },
  { to: "Services", label: "Services" },
  { to: "Expérience", label: "Expérience" },
  { to: "Portfolio", label: "Portfolio" },
  { to: "Témoignages", label: "Témoignages" },
];

function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const closeMenu = () => setOpen(false);

  return (
    <header className={`n-wrapper ${scrolled ? "is-scrolled" : ""}`} id="Accueil">
      <div className="n-inner container">
        <div className="n-left">
          <a className="n-brand" href="#Accueil" onClick={closeMenu}>
            <img src={LogoAdele} alt="Adele" className="n-logo" width="36" height="36" />
            <span className="n-name">Adèle</span>
          </a>
          <Toggle />
        </div>

        <nav className={`n-right ${open ? "is-open" : ""}`} aria-label="Navigation principale">
          <div className="n-list">
            <ul>
              {links.map((item) => (
                <li key={item.to}>
                  <Link
                    spy
                    smooth
                    offset={-80}
                    duration={500}
                    to={item.to}
                    activeClass="activeClass"
                    onClick={closeMenu}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <Link
            spy
            smooth
            offset={-80}
            duration={500}
            to="Contact"
            activeClass="activeClass"
            onClick={closeMenu}
          >
            <button type="button" className="button n-button">
              Contact
            </button>
          </Link>
        </nav>

        <button
          type="button"
          className={`n-burger ${open ? "is-open" : ""}`}
          aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
          aria-expanded={open}
          onClick={() => setOpen((prev) => !prev)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>
      {open ? <button type="button" className="n-backdrop" aria-label="Fermer" onClick={closeMenu} /> : null}
    </header>
  );
}

export default Navbar;
